<template>
  <div class="wrapper">
    <web-header></web-header>

    <div class="web-contain">
      <router-view></router-view>
    </div>

    <web-footer></web-footer>

    <!-- 全局登录/注册弹窗 -->
    <login-dialog></login-dialog>
  </div>
</template>

<script>
import webHeader from './header'
import webFooter from './footer'
import LoginDialog from '@/components/LoginDialog'

export default {
  components: {
    webHeader,
    webFooter,
    LoginDialog
  },
  data () {
    return {}
  },
  computed: {},
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.web-contain {
  padding-top: 70px;
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/main.vue